import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import UserPrefsService from "../../../services/UserPrefsService";
import ProfilCheckOption from "./ProfilCheckOption";
import CompteUserForm from "./CompteUserForm";
import CompteEntityForm from "./CompteEntityForm";
import CompteLeaderUsersList from "./CompteLeaderUsersList";
import Icon from "@mdi/react";
import { mdiLoading } from "@mdi/js";
import ParametersStamp from "./ParametresStamp";
import ProfilAddUser from "./ProfilAddUser";
import Styles from "./Compte.scss";

const Compte = (props) => {
   const [isLoading, setIsLoading] = useState(false);
   const [entity, setEntity] = useState([]);
   const [user, setUser] = useState([]);
   const [logoFiles, setLogoFiles] = useState([]);
   const userPrefsService = new UserPrefsService();
   const [filteredData, setFilteredData] = useState([]);
   const [pageCount, setPageCount] = useState(8);
   const [currentIndex, setCurrentIndex] = useState(0);

   const [formAnnexes, setFormAnnexes] = useState({
      delivrance_txt: null,
      intro_txt: null,
      a1_txt: null,
      a2_txt: null,
      a5_ta: null,
      a5_td: null,
      a5_rap: null,
      a6_txt1: null,
      a6_txt2: null,
   });

   useEffect(() => {
      fetchEntityAndUserInfo();
   }, []);

   useEffect(
      () => () => {
         logoFiles.forEach((file) => URL.revokeObjectURL(file.preview));
      },
      [logoFiles]
   );

   useEffect((e) => {}, [props.entity]);

   useEffect(
      () => {
         updatePrefsAccess();
      },
      [props.user]
   );

   useEffect(() => {
      setPrefsAccess(updatePrefsAccess());
   }, [props.userPrefs]);

   const updatePrefsAccess = () => {
      let access = userPrefsService.getInitialesPrefs().access;
      let result = [];
      if (props?.userPrefs?.access?.length) {
         access.map((item) => {
            result.push(props.userPrefs.access.find((e) => e.name === item.name) ?? item);
         });
         return result;
      } else {
         return access;
      }
   };
   const [prefsAccess, setPrefsAccess] = useState(updatePrefsAccess);

   const onSubmit = (data) => {
      let dataUser = {
         name: data.user_name,
         username: data.user_username,
      };
      let dataEntity = {
         id: entity.id,
         address: data.entity_address,
         address2: data.entity_address2,
         cp: data.entity_cp,
         city: data.entity_city,
         email: data.entity_email,
         phone: data.entity_phone,
         phone2: data.entity_phone2,
         // header data
         header_name: data.header_name,
         header_address: data.header_address,
         header_city: data.header_city,
         header_cp: data.header_cp,
         header_email: data.header_email,
         header_code: data.header_code,
         header_phone: data.header_phone,
         sign_text: data.sign_text,

         new_logo: entity.new_logo ? entity.new_logo : null,
         new_logo_name: entity.new_logo_name ? entity.new_logo_name : null,
         new_stamp: entity.new_stamp ? entity.new_stamp : null,
         new_stamp_name: entity.new_stamp_name ? entity.new_stamp_name : null,
         annexes: {
            ...data,
            delivrance_txt: data?.delivrance_txt ? data?.delivrance_txt : null,
            intro_txt: data?.intro_txt ? data?.intro_txt : null,
            a1_txt: data?.a1_txt ? data?.a1_txt : null,
            a2_txt: data?.a2_txt ? data?.a2_txt : null,
            a5_ta: data?.a5_ta ? data?.a5_ta : null,
            a5_td: data?.a5_td ? data?.a5_td : null,
            a5_rap: data?.a5_rap ? data?.a5_rap : null,
            a6_txt1: data?.a6_txt1 ? data?.a6_txt1 : null,
            a6_txt2: data?.a6_txt2 ? data?.a6_txt2 : null,
         },
         setFormAnnexes: {
            delivrance_txt: data?.delivrance_txt ? data?.delivrance_txt : null,
            intro_txt: data?.intro_txt ? data?.intro_txt : null,
            a1_txt: data?.a1_txt ? data?.a1_txt : null,
            a2_txt: data?.a2_txt ? data?.a2_txt : null,
            a5_ta: data?.a5_ta ? data?.a5_ta : null,
            a5_td: data?.a5_td ? data?.a5_td : null,
            a5_rap: data?.a5_rap ? data?.a5_rap : null,
            a6_txt1: data?.a6_txt1 ? data?.a6_txt1 : null,
            a6_txt2: data?.a6_txt2 ? data?.a6_txt2 : null,
         },
      };
      handleUpdateUser(dataUser);
      handleUpdateEntity(dataEntity);
   };

   const fetchEntityAndUserInfo = async () => {
      setIsLoading(true);
      try {
        const [resultEntity, resultUser] = await Promise.all([
          axios.get("/Api/user/entity"),
          axios.get("/Api/user"),
        ]);
    
        if (resultEntity?.data?.header_form_ref?.header_option) {
          const optionParsed = JSON.parse(resultEntity.data.header_form_ref.header_option);
          resultEntity.data.header_form_ref.header_option = optionParsed;
          setFormAnnexes(optionParsed);
        }
    
        props.updateStructureInfo(resultEntity.data);
        props.updateUserInfo(resultUser.data);
        setEntity(resultEntity.data);
        setUser(resultUser.data);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        toast.error("Un problème est survenu lors de l'actualisation de vos données");
      }
    };
    
   const handleUpdateEntity = async (data) => {
      const args = { data };
      try {
         const result = await axios.post("/Api/user/entity", args);

         result.data ? toast.success("Actualisation de vos données de structure réussie", { id: "structure" }) : null;
      } catch (err) {
         console.log(err);
         toast.error("Un problème est survenu lors de l`'actualisation de vos données de structure");
      }
   };

   const handleUpdateUser = async (data) => {
      const args = { data };
      try {
         const result = await axios.put("/Api/user", args);
         result.data ? toast.success("Actualisation de vos données utilisateur réussie", { id: "user" }) : null;
      } catch (err) {
         toast.error("Un problème est survenu lors de l`'actualisation de vos données");
      }
   };

   const handleUSerInputChange = (event) => {
      const target = event.target;
      const value = target.value;
      const name = target.name;

      setUser({
         ...user,
         [name]: value,
      });
   };

   const handleOnCheck = () => {};
   const [showModal, setShowModal] = useState(false);

   const handleClick = () => {
      // Mettez à jour l'état pour afficher la modal
      setShowModal(true);
   };

   const handleCloseModal = () => {
      // Mettez à jour l'état pour cacher la modal
      setShowModal(false);
      fetchEntityAndUserInfo();
   };
   const setPaginationUrl = () => {
      let content = [];
      let indexStart = 0;
      for (let i = 0; i < filteredData.length; i += pageCount) {
         content.push(
            <li key={i} className="page-item">
               <a className="page-link" href="#" onClick={(e) => setCurrentIndex(i)}>
                  {indexStart + 1}
               </a>
            </li>
         );
         indexStart += 1;
      }
      return content;
   };
   return (
      <div className={"container-fluid text-dark w-100"}>
         <div className="row">
            <div className="col-12 col-lg-6 mb-2">
               <div className={"d-flex flex-column flex-lg-row p-3 rounded bg-white"}>
                  {props?.entity?.genre?.slug === "collective" ? <ParametersStamp /> : <></>}
                  <div className={"d-flex flex-column justify-content-start align-items-start w-100 "}>
                     <h5 className={"my-4 font-weight-bold"}>Ma Structure</h5>
                     {isLoading ? (
                        <div className="w-100 text-center">
                           <Icon path={mdiLoading} spin={true} size={1} color={"var(--theme-primary)"} />
                        </div>
                     ) : (
                        <CompteEntityForm entity={entity} />
                     )}
                  </div>
               </div>
            </div>

            <div className="col-12 col-lg-6">
               <div className={"d-flex flex-column p-3 justify-content-start align-items-start rounded bg-white"}>
                  <h5 className={"my-4 font-weight-bold"}>Mon compte</h5>
                  {isLoading ? (
                     <div className="w-100 text-center">
                        <Icon path={mdiLoading} spin={true} size={1} />
                     </div>
                  ) : (
                     <CompteUserForm user={user} />
                  )}
               </div>
            </div>
         </div>
         
         <div className="row h-100"> 
            <div className={"col-12 h-100"}>
               <div className={"d-flex p-3 flex-column justify-content-start rounded w-100 bg-white mt-2"}>
                  {isLoading ? (
                     <div className="w-100 text-center">
                        <Icon path={mdiLoading} spin={true} size={1} color={"var(--theme-primary)"} />
                     </div>
                  ) : true ? (
                     <>
                        <div
                           style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "end",
                           }}
                           className="pb-5"
                        >
                           <h5 className={"my-3"} style={{ fontWeight: "800" }}>
                              Utilisateurs {props?.entity?.name}
                           </h5>
                           {(props?.entity?.genre?.slug === "collective" && ( props.role === "admin" || props.role === "gestion"||props.isLeader)) &&(
                              <>
                              <button 
                              className="btn btn-primary text-white"
                              style={{
                                 height: "2rem",
                                 fontWeight: "800",
                                 borderRadius: "8px",
                              }}
                              onClick={handleClick}
                           >
                              <svg
                                 xmlns="http://www.w3.org/2000/svg"
                                 width="16"
                                 height="16"
                                 fill="currentColor"
                                 class="bi bi-plus-circle-fill"
                                 viewBox="0 0 16 16"
                                 style={{ marginRight: "4px" }}
                              >
                                 <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
                              </svg>
                              Utilisateur
                           </button>

                           {showModal && <ProfilAddUser onClose={handleCloseModal} onSubmit={onSubmit} entityId={props.entity.id} />}
                              </>
                           )}
                           
                        </div>

                        <CompteLeaderUsersList users={null} />
                        <nav aria-label="">
                           <ul className="pagination justify-content-center">
                              <li className="page-item">
                                 <a
                                    className="page-link"
                                    href="#"
                                    aria-label="Previous"
                                    onClick={(e) => setCurrentIndex(0)}
                                 >
                                    <span aria-hidden="true">&laquo;</span>
                                 </a>
                              </li>
                              {filteredData?.length ? setPaginationUrl() : null}
                              <li className="page-item">
                                 <a
                                    className="page-link"
                                    href="#"
                                    aria-label="Next"
                                    onClick={(e) => setCurrentIndex(filteredData?.length - pageCount)}
                                 >
                                    <span aria-hidden="true">&raquo;</span>
                                 </a>
                              </li>
                           </ul>
                        </nav>
                     </>
                  ) : (
                     <div className={"w-100"}>
                        <h6 className={"my-3 font-weight-bold"}>Droit de consultation</h6>
                        {prefsAccess.map((item, index) => (
                           <ProfilCheckOption
                              key={index}
                              label={item.label}
                              title={item.title}
                              name={item.name}
                              checked={item.checked}
                              onCheck={handleOnCheck}
                           />
                        ))}
                     </div>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      userPrefs: state.MeReducer.prefs,
      username: state.MeReducer.username,
      isLeader: state.MeReducer.isLeader,
      role: state.MeReducer.role,
      types: state.SubscribtionReducer.types,
      structureInfo: state.SubscribtionReducer.structureInfo,
      entity: state.MeReducer.entity,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateStructureInfo: (e) => dispatch({ type: "UPDATE_STRUCTURE_INFO", data: e }),
      updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(Compte);
